<template>
    <div>
        <h3 class="font-semibold text-gray-700 text-lg/none">{{ props.headline }}</h3>
        <ol class="columns-2 mt-1">
            <li
                v-for="federalState in props.federalStates"
                :key="federalState.id"
                class="flex flex-row items-center gap-2"
                :class="federalState.isOccupied ? 'text-gray-700 font-semibold' : 'text-gray-400'"
            >
                <LocationOnIcon v-if="federalState.isOccupied" />
                <LocationOffIcon v-else />
                {{ federalState.name }}
            </li>
        </ol>
    </div>
</template>

<script setup lang="ts">
import LocationOffIcon from '../Icon/LocationOffIcon.vue';
import LocationOnIcon from '../Icon/LocationOnIcon.vue';

type FederalStatesTooltipProps = {
    headline: string;
    federalStates: { id: string; name: string; isOccupied: boolean }[];
};

const props = defineProps<FederalStatesTooltipProps>();
</script>
